import React from "react";
import PropTypes from "prop-types";

//
import NumberFormat from "react-number-format";

//
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function InputShow({ label, number, text, link, copy = false }) {
  /**
   * Copy To Clipboard
   */
  const copyToClipboard = () => {
    let val = link;

    let tempInput = document.createElement("input");

    tempInput.value = val;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");

    toast.success("copy to clipboard", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });
    document.body.removeChild(tempInput);
  };

  return (
    <div className="input-show">
      <small>{label}</small>

      {link && (
        <span className="link-holder">
          <a href={link} target="_blank" className="text-info fw-bold">
            <small>{link ? link : "-"}</small>
          </a>
          {copy && (
            <i
              className="las la-copy text-info ms-1 pointer"
              onClick={() => copyToClipboard()}
            />
          )}
        </span>
      )}

      {number && (
        <small className="text-black fw-bold">
          {number ? (
            <NumberFormat
              value={number}
              displayType={"text"}
              thousandSeparator={true}
              decimalSeparator="."
            />
          ) : (
            "-"
          )}
        </small>
      )}

      {
        text && (
          <small className="text-black fw-bold">{text}</small>
        )
      }
    </div>
  );
}

InputShow.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  copy: PropTypes.bool,
};

export default InputShow;
